import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BasicModal from "src/features/student-attendance/components/modal";
import BusEditForm from "./bus-edit-form";
import BusesUpdateConfirm from "./buses-update-confirm";

const BusUpdateButton = ({ bus }) => {
  const [openEditModal, setOpenEditModal] = useState(false);
  const [updatePayload, setUpdatePayload] = useState(null);

  const handleSubmit = payload => {
    setUpdatePayload({ ...payload, id: bus.id });
    setOpenEditModal(false);
  };

  const handleUpdateConfirmClose = () => {
    setUpdatePayload(null);
  };

  const handleUpdateConfirmBack = () => {
    setOpenEditModal(true);
    setUpdatePayload(null);
  };

  return (
    <>
      <span>
        <button
          className="btn btn-primary w-100 btn-sm-custom"
          onClick={() => setOpenEditModal(true)}
        >
          <FontAwesomeIcon icon="edit" />
        </button>
      </span>

      {/* Edit Modal - Individual modal for this row */}
      <BasicModal
        title={`バス編集 - ${bus?.name || "バス"}`}
        isOpen={openEditModal}
        onCancel={() => setOpenEditModal(false)}
        width="50%"
      >
        <BusEditForm
          key={`edit-${bus?.id}`}
          selectedBus={bus}
          onSubmit={handleSubmit}
          onCancel={() => setOpenEditModal(false)}
        />
      </BasicModal>

      {/* Update Confirmation Modal - Individual modal for this row */}
      <BasicModal
        title={`バス更新の確認 - ${bus?.name || "バス"}`}
        isOpen={updatePayload !== null}
        onCancel={handleUpdateConfirmClose}
        width="50%"
      >
        <BusesUpdateConfirm
          key={`update-confirm-${bus?.id}`}
          updatePayload={updatePayload}
          onClose={handleUpdateConfirmClose}
          onBack={handleUpdateConfirmBack}
        />
      </BasicModal>
    </>
  );
};

export default BusUpdateButton;
